module.exports = __webpack_public_path__ + "img/xiazai.5b15117f.png";